<script>
  import Signup from "../routes/Common/Signup.svelte"
  import PageBase from "../components/pages/PageBase.svelte";
  import LoginTitle from "../components/layout/LoginTitle.svelte";
  import {getAppContext} from "../AppContext.js";


  const appContext = getAppContext()
  const version = $appContext.package?.version ?? "__MY_SCHEDULE_VERSION__"
</script>

<PageBase>
  <slot slot="header">
    <LoginTitle title={`Asprova My Schedule (ver. ${version})`} />
  </slot>
  <Signup />
</PageBase>
